module.exports = __webpack_public_path__ + "static/img/1122.361405fe.png";